import CookieBanner from './cookieBanner';

export type { CookieBannerProps } from './interface';
export default CookieBanner;
